import {Button, Loader, MobileDrawer as Drawer, UnstableCard as Paper} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import * as classes from './BoundCardModal.classes'
import {useBoundCardModal} from './BoundCardModal.hooks'
import type {Props} from './BoundCardModal.types'
import {PaymentCardList} from './PaymentCardList.mobile'
import {TrustModal} from './TrustModal.mobile'

export const BoundCardModal = memo<Props>(function BoundCardModal(props) {
  const {onClose} = props
  const {
    key,
    isPending,
    error,
    cards,
    card,
    agreement,
    fetchBoundCard,
    fetchCardBoundContext,
    successHandler,
    updateHandler,
  } = useBoundCardModal(props)

  function renderChildren() {
    if (isPending) {
      return (
        <Paper>
          <Loader />
        </Paper>
      )
    }

    if (cards) {
      if (cards.length > 0) {
        return (
          <PaymentCardList
            agreement={agreement}
            card={card}
            cards={cards}
            fetchBoundCard={fetchBoundCard}
            fetchCardBoundContext={fetchCardBoundContext}
            onAdd={updateHandler}
            onSuccess={successHandler}
          />
        )
      }

      return <TrustModal fetchCardBoundContext={fetchCardBoundContext} onClose={onClose} onSuccess={updateHandler} />
    }

    if (error) {
      return (
        <Button onPress={updateHandler} variant="error">
          Повторить
        </Button>
      )
    }

    return '🤷'
  }

  return (
    <Drawer key={key} className={classes.drawer} disableCloseButton="always" onClose={onClose} opened>
      {renderChildren()}
    </Drawer>
  )
})
